import ChartState from '../../../Insights/ChartState'

export default class MLConfig {
    constructor() {
        this.modelType = 'cluster'
        this.config = ChartState.getDefaultConfig()
        this.filterDate = null
        this.targetColumn = ''
        this.selectedFields = null
        this.filter = null
        this.filterDescription = null
        this.selectedFilters = null
        this.groupOneFilters = null
        this.groupTwoFilters = null
        this.dateToUse = null
        this.periodOneConfig = ChartState.getDefaultConfig()
        this.periodTwoConfig = ChartState.getDefaultConfig()
        this.periodOneConfig.timeRange = 'Last Week'
        this.periodTwoConfig.timeRange = 'Last Quarter'
    }
}
